module.exports = __webpack_public_path__ + "static/Brex-364acce157a7e7af51d8561c02dfc94f.png";